export default "__VITE_ASSET__udStbqRw__"